import React from 'react';
import './Header.css';
import LogoButton from './LogoButton';
import SearchBar from './SearchBar';
import UserDropdown from './UserDropdown';

function Header() {
  return (
    <div className="header">
      <LogoButton />
      <SearchBar />
      <UserDropdown />
    </div>
  );
}

export default Header;